// Vehicle segment categories
export const VEHICLE_SEGMENT_LIST = [
    { id: "SMALL", name: "Small" },
    { id: "MEDIUM", name: "Medium" },
    { id: "LARGE", name: "Large" },
    { id: "PREMIUM", name: "Premium" }
];
